import xhr from 'xhr';
import Promise from 'promise-polyfill';

// if promise if not available IE 11
if (!window.Promise) {
  window.Promise = Promise;
}

export default class SearchTap {
  constructor(key, clientId) {
    this.key = key;
    this.clientId = clientId;
  }

  search(query, collection, options = {}) {

    let searchQuery = {
      query: query,
      fields: options.fields || [],
      searchFields: options.searchFields || [],
      facets: options.facets || [],
      offset: options.offset || 0,
      pageSize: options.pageSize || 10,
      filters: options.filters || [],
      filter: options.filter || null,
      sort: options.sort || [],
      highlightFields: options.highlightFields || [],
      facetFilters: options.facetFilters || {},
      facetCount: options.facetCount || 10,
      typoTolerance: options.typoTolerance !== undefined ? options.typoTolerance : 1,
      geo: options.geo || {}
    };

    let reqOptions = {
      method: 'POST',
      url: this.getQueryUrl(collection),
      body: JSON.stringify(searchQuery),
      headers: {
        'Content-Type': 'application/json',
        'X-Auth-Token': this.key
      }
    };

    return new Promise((resolve, reject) => {
      xhr(reqOptions, function (err, response, body) {
        if (err) {
          reject(err);
        }

        resolve(JSON.parse(body));
      });
    });
  }

  getQueryUrl(collectionName) {
    return this.clientId === undefined || this.clientId === null ?
      `https://api.searchtap.net/v1/collections/${collectionName}/query` :
      `https://${this.clientId}.searchtap.net/v1/collections/${collectionName}/query`;
  }
}



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/index.js
 **/